export const ButtonFullWidth = {
  transclude: true,

  bindings: {
    modalTarget: '@',
    onClick: '&',
  },

  template: `
    <button
      type="button"
      class="btn btn-lg btn-full-width theme-btn font-weight-bold sm-word-wrap rounded-0 w-100 py-3"
      ng-attr-data-toggle="{{ $ctrl.modalTarget ? 'modal' : '' }}"
      data-target="{{ $ctrl.modalTarget }}"
      ng-click="$ctrl.onClick()">
      <i class="fa fa-angle-double-right" aria-hidden="true"></i>
      <ng-transclude></ng-transclude>
      <i class="fa fa-angle-double-left" aria-hidden="true"></i>
    </button>`,
};



// WEBPACK FOOTER //
// ./src/components/Button/ButtonFullWidth.js